var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNearby = function SvgNearby(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 14 3.965 7.963C3.35 7.088 3 6.038 3 4.988 3 2.188 5.193 0 8 0s5 2.188 5 5.075c0 1.138-.35 2.1-.965 2.888zM8 2.975c-1.14 0-2.018.875-2.018 2.012S6.86 7 8 7s2.018-.875 2.018-2.013S9.14 2.976 8 2.976"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M11 13.134c1.144.11 2.038.28 2.543.483.506.204.594.43.253.642-.342.213-1.096.4-2.143.534C10.605 14.927 9.32 15 8 15c-1.32 0-2.605-.073-3.653-.207-1.047-.134-1.8-.321-2.143-.534-.341-.213-.253-.438.253-.642s1.4-.373 2.543-.483"
  })));
};
export default SvgNearby;